import React from 'react';
import ContributorItem from './ContributorItem';
import { useTopContributors } from '../hooks/use-contributors';

const ContributorsList = () => {
  const { data, isLoading } = useTopContributors();

  if (isLoading) {
    return (
      <div>
        <h3 className="text-sm font-semibold text-text-black mb-3">Top Contributors</h3>
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-accent-indigo"></div>
        </div>
      </div>
    );
  }

  const contributors = data?.data || [];

  return (
    <div>
      <h3 className="text-sm font-semibold text-text-black mb-3">Top Contributors</h3>
      <div className="divide-y divide-gray-100">
        <div className="text-xs text-light-gray py-2 text-center">
          None
        </div>
      </div>
    </div>
  );
};

export default ContributorsList;